<template>
  <main :class="{ mDispActive: mission_display, greenback: greenback }">
    <div
      id="mission_disp"
      v-if="mission_display"
      @click="mission_display = !mission_display"
    >
      <div class="mission_disp_title">
        <p class="mission_disp_title_no">{{ result.ID }}</p>
        <h2>{{ result.name }}</h2>
      </div>
      <ul class="mission_disp_challenge_img" v-if="select_challenge">
        <template v-if="challenge_active_enough">
          <li v-for="(n, i) in result_challenge" :key="i">
            <p class="challenge_img_cat">
              <template v-if="n.cat == 1">装備指定</template>
              <template v-if="n.cat == 2">ビークル指定</template>
              <template v-if="n.cat == 3">特殊条件</template>
            </p>
            <h3 class="challenge_img_title">
              {{ n.title }}
            </h3>
          </li>
        </template>
      </ul>
    </div>
    <div id="missionselector" v-if="!mission_display">
      <div id="challengev3setting" v-if="setting_open">
        <div class="challengev3setting_inner">
          <h3>SETTING</h3>
          <div class="challengev3setting_list">
            <h4>チャレンジ項目数</h4>
            <div class="selectbox">
              <input
                type="radio"
                id="challenge_val1"
                value="1"
                v-model="result_challenge_val"
              />
              <label for="challenge_val1">1</label>
              <input
                type="radio"
                id="challenge_val2"
                value="2"
                v-model="result_challenge_val"
              />
              <label for="challenge_val2">2</label>
              <input
                type="radio"
                id="challenge_val3"
                value="3"
                v-model="result_challenge_val"
              />
              <label for="challenge_val3">3</label>
              <input
                type="radio"
                id="challenge_val4"
                value="rnd"
                v-model="result_challenge_val"
              />
              <label for="challenge_val4">RND</label>
            </div>
            <h4>WEAPON</h4>
            <ul>
              <li
                v-for="(n, i) in challenge_list_cat.weapon"
                :key="i"
                :class="{
                  weapon: n.cat == 1,
                  vehicle: n.cat == 2,
                  objective: n.cat == 3,
                }"
              >
                <input
                  type="checkbox"
                  :id="i + n.title"
                  v-model="n.available"
                />
                <label :for="i + n.title">{{ n.title }}</label>
              </li>
            </ul>
            <h4>VEHICLE</h4>
            <ul>
              <li
                v-for="(n, i) in challenge_list_cat.vehicle"
                :key="i"
                :class="{
                  weapon: n.cat == 1,
                  vehicle: n.cat == 2,
                  objective: n.cat == 3,
                }"
              >
                <input
                  type="checkbox"
                  :id="i + n.title"
                  v-model="n.available"
                />
                <label :for="i + n.title">{{ n.title }}</label>
              </li>
            </ul>
            <h4>ETC</h4>
            <ul>
              <li
                v-for="(n, i) in challenge_list_cat.objective"
                :key="i"
                :class="{
                  weapon: n.cat == 1,
                  vehicle: n.cat == 2,
                  objective: n.cat == 3,
                }"
              >
                <input
                  type="checkbox"
                  :id="i + n.title"
                  v-model="n.available"
                />
                <label :for="i + n.title">{{ n.title }}</label>
              </li>
            </ul>
          </div>
          <button
            class="challenge_setting_button"
            @click="setting_open = !setting_open"
          >
            [X] 設定を閉じる
          </button>
        </div>
      </div>
      <div id="top_contents">
        <div id="header">
          <p class="next_mission" @click="mission_display = true">
            EDF6 MISSION SELECTOR 260121
          </p>
          <div class="online-checkbox">
            <p>チャレンジモード3.1</p>
            <input
              type="checkbox"
              id="checkbox-online"
              v-model="select_challenge"
              @change="targetselect"
            />
            <label for="checkbox-online" class="label">
              <p>オン</p>
              <p>オフ</p>
            </label>
          </div>
        </div>
        <div id="result">
          <div id="result_content" class="transition">
            <h2>
              <template v-if="result.ID">{{ result.ID }}</template>
              <template v-else>--</template>
            </h2>
            <h1>{{ result.name }}</h1>
            <div class="location">
              <h4>LOCATION</h4>
              <img :src="require(`@/assets/sta${result.status}.png`)" />
            </div>
            <div id="challenge" v-if="select_challenge">
              <h4>CHALLENGE MODE 3.1</h4>
              <ul class="challenge_img" @click="challenge_reroll()">
                <template v-if="challenge_active_enough">
                  <li v-for="(n, i) in result_challenge" :key="i">
                    <p class="challenge_img_cat">
                      <template v-if="n.cat == 1">装備指定</template>
                      <template v-if="n.cat == 2">ビークル指定</template>
                      <template v-if="n.cat == 3">特殊条件</template>
                    </p>
                    <h3 class="challenge_img_title">
                      {{ n.title }}
                    </h3>
                  </li>
                </template>
                <template v-else>
                  <p style="color: red" @click="challenge_reroll()">
                    チャレンジ項目が少ないか、選択されていないようです。設定を開いて項目数を増やしてください。
                    タップで再試行
                  </p>
                </template>
              </ul>
              <button
                class="challenge_setting_button"
                @click="setting_open = !setting_open"
              >
                チャレンジ項目設定
              </button>
            </div>
          </div>

          <div id="loading" class="transition">
            <div class="loading_icon">
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        </div>
      </div>
      <div id="bottom_contents">
        <h4 id="btn_next" class="transition" @click="start">NEXT</h4>
        <div id="setting">
          <div id="missionpack" :class="{ active: missionpackVisiblity }">
            <h3>MISSION PACK</h3>
            <ul id="checkbox">
              <li>
                <input
                  type="checkbox"
                  id="checkbox-main"
                  v-model="select_main"
                  @change="targetselect"
                />
                <label for="checkbox-main" class="label">
                  <p>
                    <span>EDF6</span>
                    <span>本編</span>
                  </p>
                </label>
              </li>

              <li>
                <input
                  type="checkbox"
                  id="checkbox-dlc1"
                  v-model="select_dlc1"
                  @change="targetselect"
                />
                <label for="checkbox-dlc1" class="label">
                  <p>
                    <span>DLC1</span>
                    <span>LOST DAYS</span>
                  </p>
                </label>
              </li>
              <li>
                <input
                  type="checkbox"
                  id="checkbox-dlc2"
                  v-model="select_dlc2"
                  @change="targetselect"
                />
                <label for="checkbox-dlc2" class="label">
                  <p>
                    <span>DLC2</span>
                    <span>VISIONS OF MALICE</span>
                  </p>
                </label>
              </li>
            </ul>
          </div>
          <div id="log" :class="{ active: logVisiblity }">
            <h3>LOG</h3>
            <ul class="mission_log">
              <li v-for="(m, i) in log" :key="i">
                {{ m }}
              </li>
            </ul>
          </div>
          <ul class="hidebtn">
            <li
              :class="{ active: missionpackVisiblity }"
              @click="missionpackVisiblity = !missionpackVisiblity"
            >
              MISSION PACK
            </li>
            <li
              :class="{ active: logVisiblity }"
              @click="logVisiblity = !logVisiblity"
            >
              LOG
            </li>
            <li :class="{ active: greenback }" @click="greenback = !greenback">
              GB-MODE
            </li>
          </ul>
        </div>
        <div id="footer">
          <ul class="credit">
            <li>
              つくったひと / ちくわ軍曹とシア
              <a
                href="https://www.youtube.com/channel/UC-8XeZPdkRf8pQVyx79MDVQ"
              >
                Youtube
              </a>
              <a href="https://twitter.com/sgt_chikuwa">X(twitter)</a>
            </li>
            <li>地球防衛軍6 / ©2022 SANDLOT ©2022 D3PUBLISHER</li>
          </ul>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      mission_display: false,
      greenback: false,
      select_main: true,
      select_challenge: true,
      select_dlc1: true,
      select_dlc2: true,
      missionpackVisiblity: true,
      logVisiblity: true,
      target: [],
      log: [],
      setting_open: false,
      result_challenge: [],
      result_challenge_val: 2,
      result: this.$missions.Main[0],
      challenge_list: [
        {
          title: "カノン砲",
          cat: "1",
          available: true,
        },
        {
          title: "カノン砲",
          cat: "1",
          available: true,
        },

        {
          title: "榴弾砲",
          cat: "1",
          available: true,
        },
        {
          title: "テンペスト",
          cat: "1",
          available: true,
        },
        {
          title: "テンペスト",
          cat: "1",
          available: true,
        },
        {
          title: "インセクトボム",
          cat: "1",
          available: true,
        },
        {
          title: "ポータブル攻撃機",
          cat: "1",
          available: true,
        },
        {
          title: "ギガントコプター",
          cat: "1",
          available: true,
        },

        {
          title: "ギガントコプター",
          cat: "1",
          available: true,
        },

        {
          title: "サプレスガン",
          cat: "1",
          available: true,
        },
        {
          title: "カテゴリ「砲兵隊」",
          cat: "1",
          available: false,
        },
        {
          title: "カテゴリ「ガンシップ」",
          cat: "1",
          available: false,
        },
        {
          title: "カテゴリ「爆撃機」",
          cat: "1",
          available: false,
        },
        {
          title: "カテゴリ「ミサイル」",
          cat: "1",
          available: false,
        },
        {
          title: "カテゴリ「衛星」",
          cat: "1",
          available: false,
        },
        {
          title: "カテゴリ「リムペットガン」",
          cat: "1",
          available: false,
        },
        {
          title: "カテゴリ「特殊」",
          cat: "1",
          available: false,
        },
        {
          title: "強襲エアクラフト",
          cat: "1",
          available: true,
        },
        {
          title: "追走カプセル",
          cat: "1",
          available: true,
        },
        {
          title: "デスバード",
          cat: "1",
          available: true,
        },
        {
          title: "ブラッカー",
          cat: "2",
          available: true,
        },
        {
          title: "グレイプ",
          cat: "2",
          available: true,
        },
        {
          title: "コンバットフレーム",
          cat: "2",
          available: true,
        },

        {
          title: "ヘリ",
          cat: "2",
          available: true,
        },
        {
          title: "タイタン",
          cat: "2",
          available: true,
        },
        {
          title: "デプスクロウラー",
          cat: "2",
          available: true,
        },
        {
          title: "バルガ",
          cat: "2",
          available: true,
        },
        {
          title: "初期体力",
          cat: "3",
          available: true,
        },
        {
          title: "トーチカ禁止",
          cat: "3",
          available: true,
        },
        {
          title: "バックパック禁止",
          cat: "3",
          available: true,
        },
        {
          title: "エレクトロン禁止",
          cat: "3",
          available: true,
        },
        {
          title: "爆撃機禁止",
          cat: "3",
          available: false,
        },
        {
          title: "機銃掃射禁止",
          cat: "3",
          available: false,
        },
        {
          title: "爆発物のみ",
          cat: "3",
          available: false,
        },
        {
          title: "救助禁止",
          cat: "3",
          available: false,
        },
      ],
      challenge_list_cat: [],
      challenge_active_enough: true,
    };
  },
  mounted() {
    this.targetselect();
    this.start();
    this.create_challenge_list();
  },
  components: {},
  methods: {
    targetselect() {
      let list = [];
      if (this.select_main) {
        list = list.concat(this.$missions.Main);
        if (this.select_online) {
          list = list.concat(this.$missions.Online);
        }
      }
      if (this.select_dlc1) {
        list = list.concat(this.$missions.DLC1);
      }
      if (this.select_dlc2) {
        list = list.concat(this.$missions.DLC2);
      }
      if (!this.select_main && !this.select_dlc1 && !this.select_dlc2) {
        list = null;
        this.log.unshift("ランダム化するミッションパックを選択してください");
      }
      this.target = list;
      console.log("ターゲット変更");
    },
    start() {
      let elm = document.getElementsByClassName("transition");
      for (var i = 0; i < elm.length; i++) {
        elm[i].classList.add("nowloading");
      }
      setTimeout(this.shuffle, 800);
    },
    challenge_reroll() {
      let arr = [];
      let numArr = [];
      let challengenum = 0;
      let resval = 1;

      for (var i = 0; i < this.challenge_list.length; i++) {
        if (this.challenge_list[i].available) {
          arr.unshift(this.challenge_list[i]);
          challengenum = challengenum + 1;
        }
      }
      if (this.result_challenge_val == "rnd") {
        resval = Math.floor(Math.random() * 3) + 1;
      } else {
        resval = this.result_challenge_val;
      }

      for (var j = 0, len = arr.length; j < resval; j++, len--) {
        let rndNum = Math.floor(Math.random() * len);
        numArr.push(arr[rndNum]);
        arr[rndNum] = arr[len - 1];
      }

      this.result_challenge = numArr;
      console.log(challengenum);
      if (challengenum >= resval) {
        this.challenge_active_enough = true;
      } else {
        this.challenge_active_enough = false;
      }
    },
    create_challenge_list() {
      let listarr = { weapon: [], vehicle: [], objective: [] };
      for (var i = 0; i < this.challenge_list.length; i++) {
        if (this.challenge_list[i].cat == 1) {
          listarr.weapon.push(this.challenge_list[i]);
        } else if (this.challenge_list[i].cat == 2) {
          listarr.vehicle.push(this.challenge_list[i]);
        } else if (this.challenge_list[i].cat == 3) {
          listarr.objective.push(this.challenge_list[i]);
        }
        this.challenge_list_cat = listarr;
      }
      console.log(this.challenge_list_cat);
    },
    shuffle() {
      if (this.target == null) {
        this.result = {
          onID: "--",
          ID: "ミッションパックを選択してください",
          name: "",
          status: "0",
        };
      } else {
        const rnd = Math.floor(Math.random() * this.target.length);
        this.result = this.target[rnd];
        this.challenge_reroll();
        this.log.unshift(this.target[rnd].name + "が選択されました");
      }
      let elm = document.getElementsByClassName("transition");
      for (var i = 0; i < elm.length; i++) {
        elm[i].classList.remove("nowloading");
      }
    },
  },
};
</script>

<style lang="scss">
html {
  background-color: transparent;
  font-size: 16px;
  touch-action: manipulation;
  // background-color: black;
}
.debug {
  opacity: 0.2;
}
body {
  margin: 0;
}
#app {
  font-family: sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin: 0;
}
main {
  width: 100%;
  height: 100svh;
  height: 100%;
  min-width: 360px;
  margin: 0;
  position: absolute;
  color: white;
  box-sizing: border-box;
  user-select: none;
  &.mDispActive {
    background-color: transparent;
  }
  &.greenback {
    background-color: #00ff00;
    padding: 2rem;
    #missionselector {
      background-color: #111;
      padding: 2rem;
      border-radius: 2rem;
      max-width: 80%;
      margin: 0 auto;
    }
  }
}
#missionselector {
  width: 100%;
  height: 100%;
  display: flex;
  padding: 2rem clamp(1rem, 5vw, 3rem) 1rem clamp(1rem, 5vw, 3rem);
  flex-direction: column;
  gap: 1rem;
  background-color: rgba(0, 0, 0, 0.9);
}
#top_contents {
  flex-grow: 1;
  display: flex;
  width: 100%;
  flex-direction: column;
}
#header {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
  .next_mission {
    margin: 0 auto;
    display: block;
    font-size: 1rem;
    font-family: $font;
    letter-spacing: 0.1em;
    width: 100%;
  }
  .online-checkbox {
    flex-shrink: 0;
    font-family: $font;
    font-size: 1rem;
    list-style-type: none;
    padding: 0;
    display: flex;
    align-items: center;
    margin-left: auto;
    gap: 0.5rem;
    input[type="checkbox"] {
      display: none;
      -webkit-appearance: none;
    }
    p {
      font-size: 0.8rem;
      text-align: right;
    }
    .label {
      width: 100%;
      display: block;
      display: flex;
      align-items: center;
      box-sizing: border-box;
      position: relative;
      height: 2rem;
      background-color: rgba(0, 0, 0, 0.9);
      border: 1px solid white;
    }
    .label p {
      width: 60%;
      font-weight: bold;
      display: inline-flex;
      z-index: 1;
      padding: 0 0.5rem;
      height: 2rem;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;
      font-size: clamp(0.5rem, 1.5vw, 1rem);
      color: #666;
      transition: 0.25s;
      span {
        display: inline-block;
      }
    }
    .label::before {
      position: absolute;
      top: 0;
      left: 0;
      display: block;
      content: "";
      width: 50%;
      height: 100%;
      background-color: #25bf3b;
      transition: 0.25s $easing;
      z-index: 0;
      right: 0;
      left: 50%;
    }
    .label p:first-child {
    }
    .label p:nth-child(2) {
      color: white;
    }
    input[type="checkbox"]:checked + .label p:nth-child(2) {
      color: #666;
    }
    input[type="checkbox"]:checked + .label p:first-child {
      color: white;
    }
    input[type="checkbox"]:checked + .label::before {
      left: 0;
      right: 50%;
      background-color: #ff0000;
    }
  }
}
#result {
  flex-grow: 1;
  text-align: center;
  line-height: 1;
  padding: 2rem 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  border-top: 2px solid white;
  border-bottom: 2px solid white;
  filter: drop-shadow(0px 0px 2rem rgba(0, 0, 0, 0.6));

  #loading {
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    display: none;
    &.nowloading {
      display: flex;
    }

    .loading_icon {
      position: relative;
      width: 120px;
      height: 120px;
      @include sp {
        transform: scale(0.5);
      }
      span {
        position: absolute;
        background-color: #25bf3b;
        width: 36px;
        height: 36px;
        animation: loading 0.8s infinite;
        &:nth-child(1) {
          top: 0;
          left: 0;
          animation-delay: 0s;
        }
        &:nth-child(2) {
          top: 0;
          left: 42px;

          animation-delay: 0.1s;
        }
        &:nth-child(3) {
          top: 0;
          right: 0;

          animation-delay: 0.2s;
        }
        &:nth-child(4) {
          top: 42px;
          right: 0;
          animation-delay: 0.3s;
        }
        &:nth-child(5) {
          bottom: 0;
          right: 0;
          animation-delay: 0.4s;
        }
        &:nth-child(6) {
          bottom: 0;
          left: 42px;
          animation-delay: 0.5s;
        }
        &:nth-child(7) {
          bottom: 0;
          left: 0;
          animation-delay: 0.6s;
        }
        &:nth-child(8) {
          top: 42px;
          left: 0;
          animation-delay: 0.7s;
        }
      }
    }
  }
  #result_content {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    transition: 0.5s;
    &.nowloading {
      opacity: 0;
    }
    .onlinestatus {
      font-family: $font;
      font-size: 1rem;
      height: 1.5rem;
      padding: 0 1rem;
      border: 1px solid white;
      display: inline-flex;
      align-items: center;
      background-color: #25bf3b;
      margin-bottom: 0.5rem;
    }
    .onlinestatus.active {
      background-color: red;
    }
    h1 {
      font-size: clamp(2rem, 10vw, 4rem);
      font-family: "A-OTF ゴシックMB101 Pro", sans-serif;
      line-height: 1;
      margin: 0;
      font-weight: bold;
      margin-top: 1rem;
    }
    h2 {
      font-size: clamp(2rem, 5vw, 3rem);
      font-family: $font;
      line-height: 1;
      margin: 0;
      letter-spacing: 0.1em;
    }
    .location {
      margin-top: 2rem;
      width: clamp(180px, 25vw, 240px);
      max-width: 40vw;
      letter-spacing: 0.1em;
      h4 {
        font-family: $font;
        font-size: 0.8rem;
        margin-bottom: 0.25rem;
      }
      img {
        height: auto;
        width: 100%;
      }
    }
    .attention {
      max-width: 80vw;
      margin: 0 auto;
      margin-top: 0.5rem;
      img {
        width: 100%;
        height: auto;
      }
    }
  }
}

#bottom_contents {
  justify-self: flex-end;
  width: 100%;
}
#setting {
  padding-top: 1rem;
  margin-bottom: 1rem;
  #setting-inner {
    height: 0;
    overflow: hidden;
  }
  #missionpack {
    display: none;
    &.active {
      display: block;
    }
  }
  .hidebtn {
    display: flex;
    font-family: $font;
    gap: 0.2em;
    li {
      font-size: 0.8rem;
      border: 1px solid #666;
      color: #666;
      padding: 0.2em 0.5em;
      &.active {
        color: white;
        background-color: #666;
      }
    }
  }
  h3 {
    font-family: $font;
    font-weight: bold;
    position: relative;
    line-height: 1;
    padding-left: 1.25rem;
    margin-bottom: 0.5rem;
    &::before {
      position: absolute;
      left: 0;
      right: 0;
      content: "";
      width: 1rem;
      height: 1rem;
      background-color: white;
    }
  }
  #checkbox {
    font-family: $font;
    font-size: 1rem;
    list-style-type: none;
    padding: 0;
    margin-bottom: 0.5rem;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 1rem;
    @include sp {
      grid-gap: 0.25rem;
    }

    li {
      line-height: 1rem;
      display: inline-flex;
      gap: 0.5em;
      padding: 0.5rem;
      border: 1px solid #666;
      background: linear-gradient(90deg, rgb(0, 0, 0), rgb(0, 0, 0));
      transition: 0.25s;
    }
    input[type="checkbox"] {
      display: none;
      -webkit-appearance: none;
    }
    .label {
      display: inline-flex;
      align-items: center;
      width: 100%;
      box-sizing: border-box;
      position: relative;
      height: 1.5rem;
      font-weight: bold;
    }
    .label p {
      position: relative;
      display: block;
      z-index: 1;
      padding-left: 2rem;
      box-sizing: border-box;
      font-size: clamp(0.8rem, 1.5vw, 1.2rem);
      span {
        display: inline-block;
        margin-right: 0.25em;
      }
    }
    .label::before {
      position: absolute;
      top: 0;
      left: 0;
      display: block;
      content: "";
      width: 1.5rem;
      height: 1.5rem;
      border: 2px solid white;
      transition: 0.25s $easing;
      z-index: 0;
    }
    .label::after {
      position: absolute;
      top: 4px;
      left: 4px;
      display: block;
      content: "";
      width: calc(1.5rem - 8px);
      height: calc(1.5rem - 8px);
      background-color: rgb(37, 101, 191);
      z-index: 0;
      opacity: 0;
    }
    li:has(input[type="checkbox"]:checked) {
      background: linear-gradient(90deg, rgb(0, 1, 39), rgb(0, 0, 0));
      filter: drop-shadow(0px 0px 4px rgba(37, 101, 191, 0.8));
    }
    input[type="checkbox"]:checked + .label::after {
      opacity: 1;
    }
  }
  #log {
    margin-bottom: 1rem;
    display: none;
    &.active {
      display: block;
    }

    ul {
      border: 1px solid #666;
      background-color: rgba(0, 0, 0, 0.9);
      height: 4rem;
      overflow-y: scroll;
      padding: 0.5rem;
    }
    li {
      font-size: 0.8rem;
      height: 1rem;
      color: #999;
      &:first-child {
        font-weight: bold;
        color: white;
        &::before {
          content: ">>";
          font-family: $font;
        }
      }
    }
  }
}

#btn_next {
  &.nowloading {
    visibility: hidden;
  }
  font-family: $font;
  font-size: 2rem;
  background-image: linear-gradient(0deg, rgb(72, 72, 72), rgb(47, 47, 47));
  color: white;
  display: block;
  width: 240px;
  line-height: 1;
  padding: 0.5rem;
  letter-spacing: 0.2em;
  margin: 0 auto;
  text-align: center;
  @include sp {
    width: 100%;

    font-size: 1.25rem;
  }
}
#footer {
  .appname {
    font-size: 1rem;
    letter-spacing: 0.1em;
    font-family: $font;
  }
  .credit {
    display: inline-flex;
    font-size: 0.8rem;
    line-height: 1.25em;
    gap: 0 2em;
    flex-wrap: wrap;
    @include sp {
      font-size: 0.6rem;
    }
    a {
      display: inline-block;
      text-decoration: underline;
      margin-left: 0.5rem;
    }
  }
}
</style>
